export default __webpack_public_path__ + "adf8927712ad9553f4828d019b8eb502.ttf";